import { makeStyles } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'
import { borderRadius } from 'react-select/src/theme'

const getAvatarBackground = (word: string | undefined) => {
  const words = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
  const backgrounds = ['#037EF3', '#00C16E', '#0CB9C1', '#F48924', '#9E44D6', '#52565E']
  const wordBackgroundIndex = words.findIndex((value) => value === word) % 6
  const notfound = wordBackgroundIndex === -1

  return notfound ? backgrounds[3] : backgrounds[wordBackgroundIndex]
}

const useStyles = makeStyles((theme) =>
  createStyles({
    accountDropDown: {
      display: 'flex',
      marginRight: '20px',
    },
    paper: {},
    root: {
      display: 'flex',
      marginRight: '20px',
    },

    name: {
      fontFamily: theme.variables.defaultFontFamily,
      fontStyle: 'normal',
      marginRight: '8px',
      lineHeight: '22px',
      textAlign: 'center',
    },

    button: {
      height: '38px',
      width: 'auto',
      display: 'flex',
      padding: '8px 12px',
      textTransform: 'none',
      color: '#202833',
      borderRadius: '8px',
      fontWeight: theme.variables.fontWeight600,
      fontSize: theme.variables.fontSize18,
      '&:hover': {
        border: '1px solid #153C78',
        borderRadius: '20px',
        backgroundColor: theme.variables.allBlue,
        color: '#FFFFFF',
        fontWeight: theme.variables.fontWeight400,
      },
    },
    account: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      borderTop: 'none',
      borderLeft: '1px solid #153C78',
      borderRight: '1px solid #153C78',
      borderBottom: 'none',
      padding: '0 10px',
    },

    menuItem: {
      fontSize: theme.variables.fontSizeMd,
      fontWeight: theme.variables.fontWeight600,
      color: theme.variables.fontColorBlack,
    },
    // avatar: ({ word }: { word: string | undefined }) => ({
    //   lineHeight: '24px',
    //   borderRadius: '50%',
    //   marginRight: '8px',
    //   width: '24px',
    //   height: '24px',
    //   backgroundColor: getAvatarBackground(word),
    //   color: '#fff',
    //   fontWeight: 400,
    // }),

    arrowDown: {
      width: '15px',
      height: '15px',
      '& > g > path': {
        fill: '#BED1F6',
      },
    },
  }),
)

export default useStyles
